function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEnergyEntry = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.69 56.69",
    style: {
      enableBackground: "new 0 0 56.69 56.69"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030405"
    },
    d: "M37.23,29.31c-0.31-0.99-1.11-1.71-2.12-1.93l-8.89-1.9l7.39-14.77c0.08-0.17,0.03-0.38-0.13-0.48 c-0.16-0.11-0.37-0.08-0.49,0.07L20.02,25.26c-0.67,0.77-0.87,1.8-0.55,2.77c0.32,0.96,1.1,1.67,2.09,1.88l9.39,2.05l0.35-0.69 l-9.58-2.09c-0.73-0.16-1.31-0.68-1.54-1.39c-0.24-0.71-0.09-1.48,0.41-2.04l11.02-12.71l-6.27,12.53c-0.05,0.1-0.05,0.23,0,0.33 c0.05,0.1,0.15,0.18,0.26,0.21l9.36,2c0.75,0.16,1.33,0.69,1.56,1.42c0.23,0.73,0.06,1.5-0.46,2.06L24.73,43.81l5.08-9.63 l-0.76-0.17l-6.31,11.97c-0.09,0.17-0.04,0.37,0.12,0.48c0.07,0.05,0.14,0.07,0.22,0.07c0.1,0,0.2-0.04,0.28-0.12l13.26-14.3 C37.31,31.35,37.55,30.3,37.23,29.31z"
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEnergyEntry, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/energy_entry.65eb2355.svg";
export { ForwardRef as ReactComponent };